import React from "react";
import Slider from "react-slick";
import Image1 from '../images/slider1.svg';
import Image2 from '../images//slider2.svg';
import Image3 from '../images/slider3.svg';
import Image4 from '../images/slider4.svg';
import Image5 from '../images/slider5.svg';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const services = [
  {
    image: Image1
  },
  {
    image: Image2
  },
  {
    image: Image3
  },
  {
    image: Image4
  },
  {
    image: Image5
  }
];

const AboutCarousel = () => {
  const settings = {
    // dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    fade: true,
    pauseOnHover: false
  };

  return (
    <div className="mx-auto ">
      <Slider {...settings}>
        {services.map((service, index) => (
          <div key={index} className="relative">
            <img src={service.image} alt={service.title} className="w-full object-cover" />
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default AboutCarousel;
